import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@apollo/client/react';
import { SeatsSectionKey } from '@src/components/sco/Advisors/utils/seatsNav';
import { BOARD_SEAT_COUNTS } from '@src/gql/queries/BoardSeatCounts';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
type CountsCollection = {
  pagination?: {
    itemCount?: number | null;
  } | null;
} | null;
type BoardSeatCountsData = Partial<Record<SeatsSectionKey | 'filled', CountsCollection>>;
const countOf = (collection: CountsCollection) => Number(collection?.pagination?.itemCount ?? 0);

/** Per-status counts for the My Advisors rail badges. */
export const useBoardSeatCounts = () => {
  const $ = _c(22);
  const {
    currentUser
  } = useCurrentUser();
  const t0 = !currentUser?.isRegistered;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      skip: t0,
      fetchPolicy: "cache-and-network"
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const query = useQuery(BOARD_SEAT_COUNTS, t1);
  const t2 = query.data?.all;
  let t3;
  if ($[2] !== t2) {
    t3 = countOf(t2);
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = query.data?.drafts;
  let t5;
  if ($[4] !== t4) {
    t5 = countOf(t4);
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = query.data?.searching;
  let t7;
  if ($[6] !== t6) {
    t7 = countOf(t6);
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = query.data?.invited;
  let t9;
  if ($[8] !== t8) {
    t9 = countOf(t8);
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const t10 = query.data?.filled;
  let t11;
  if ($[10] !== t10) {
    t11 = countOf(t10);
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t11 || $[13] !== t3 || $[14] !== t5 || $[15] !== t7 || $[16] !== t9) {
    t12 = {
      all: t3,
      drafts: t5,
      searching: t7,
      invited: t9,
      board: t11
    };
    $[12] = t11;
    $[13] = t3;
    $[14] = t5;
    $[15] = t7;
    $[16] = t9;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  const counts = t12;
  const t13 = query.loading && !query.data;
  let t14;
  if ($[18] !== counts || $[19] !== query.refetch || $[20] !== t13) {
    t14 = {
      counts,
      loading: t13,
      refetch: query.refetch
    };
    $[18] = counts;
    $[19] = query.refetch;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  return t14;
};